<template>
    <div class="results">
        <div class="row">
            <div class="col-8 results-container">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-8">
                                <h2>{{ init.title }}</h2>
                            </div>
                            <div class="col-2 floating_label">
                                <datepicker-utc 
                                    v-model="init.start_month" 
                                    :monthPicker="true"
                                    :inputFormat="'MMM yyyy'" 
                                    input-class="form-control">
                                </datepicker-utc>
                                <label>From</label>
                            </div>
                            <div class="col-2 floating_label">
                                <datepicker-utc 
                                    v-model="init.end_month" 
                                    :monthPicker="true"
                                    :inputFormat="'MMM yyyy'" 
                                    input-class="form-control">
                                </datepicker-utc>
                                <label>To</label>
                            </div>
                        </div>
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">Metric</th>
                                    <th scope="col">Projection</th>
                                    <th scope="col">Actual</th>
                                    <th scope="col">Variance</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>CPM</td>
                                    <td>$4.23</td>
                                    <td>$3.45</td>
                                    <td class="positive-4">-41%</td>
                                </tr>
                                <tr>
                                    <td>Click Rate</td>
                                    <td>1.3%</td>
                                    <td>1.4%</td>
                                    <td class="positive-1">8%</td>
                                </tr>
                                <tr>
                                    <td>Email Sign Up Rate</td>
                                    <td>43%</td>
                                    <td>35%</td>
                                    <td class="negative-2">-19%</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="row">
                            <div class="col">
                                <a :href="'/results/' + client.url + '/projections'" class="btn btn-secondary" style="text-decoration: none;">
                                    <i class="fa fa-check"></i> Finished
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <div class="col-10">
                                <h3>Assigned Results</h3>
                            </div>
                            <div class="col text-right">
                                <button type="button" 
                                    class="btn-sm btn-secondary"
                                    @click="modal_version = 'Result'">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card" v-if="init.results_filter === null || init.results_filter.length === 0">
                            <div class="card-body">
                                None Added Yet
                            </div>
                        </div>
                        <template v-else>
                            <div class="card" v-for="result in init.results_filter" :key="result.id">
                                <div class="row">
                                    <div class="col-9">
                                        <button class="btn btn-link text-left collapsed" 
                                            type="button" 
                                            data-toggle="collapse" 
                                            :data-target="'#result-' + result.id"  
                                            :aria-controls="'result-' + result.id">
                                            <strong>{{ propercase(result.data_source) }}</strong>: {{ result.description }}
                                        </button>
                                    </div>
                                    <div class="col text-right">
                                        <button type="button" 
                                            class="btn-xs btn-none" 
                                            @click="editResult(result)">
                                            <img class="icon" src="/img/icons/avid-icons/edit.svg" alt="">
                                        </button>
                                        <button type="button" 
                                            class="btn-xs btn-none" 
                                            @click="deleteResult(result)">
                                            <i class="fa fa-remove"></i>
                                        </button>
                                    </div>
                                </div>
                                <div :id="'result-' + result.id" 
                                    class="collapse card-body" 
                                    v-if="result.data_source === 'manual'">
                                    <strong>Date:</strong> {{ date(result.date) }}<br>
                                    <strong>Emails:</strong> {{ number_with_zero(result.emails) }}<br>
                                    <strong>Gifts:</strong> {{ number_with_zero(result.gifts) }}<br>
                                    <strong>New Donors:</strong> {{ number_with_zero(result.new_donors) }}<br>
                                    <strong>Revenue:</strong> {{ currency_with_zero(result.revenue) }}<br>
                                    <strong>Recurring Revenue:</strong> {{ currency_with_zero(result.recurring_revenue) }}
                                </div>
                                <div :id="'result-' + result.id" 
                                    class="collapse card-body" 
                                    v-else>
                                    <strong>Filter Logic:</strong><br>
                                    <div style="line-height: 2.4em;" v-html="logicToString(result.value.filter_logic, result.value.logic_units)"></div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="row" style="margin-top:30px;">
                    <div class="col">
                        <div class="row">
                            <div class="col-10">
                                <h3>Assigned Costs</h3>
                            </div>
                            <div class="col text-right">
                                <button type="button" 
                                    class="btn-sm btn-secondary"
                                    @click="modal_version = 'Cost'">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card" v-if="init.costs_filter === null || init.costs_filter.length === 0">
                            <div class="card-body">
                                None Added Yet
                            </div>
                        </div>
                        <template v-else>
                            <div class="card" v-for="cost in init.costs_filter" :key="cost.id">
                                <div class="row">
                                    <div class="col-9">
                                        <button class="btn btn-link text-left collapsed" 
                                            type="button" 
                                            data-toggle="collapse" 
                                            :data-target="'#cost-' + cost.id"  
                                            :aria-controls="'cost-' + cost.id">
                                            <strong>{{ propercase(cost.data_source) }}</strong>: {{ cost.description }}
                                        </button>
                                    </div>
                                    <div class="col text-right">
                                        <button type="button" 
                                            class="btn-xs btn-none" 
                                            @click="editCost(cost)">
                                            <img class="icon" src="/img/icons/avid-icons/edit.svg" alt="">
                                        </button>
                                        <button type="button" 
                                            class="btn-xs btn-none" 
                                            @click="deleteCost(cost)">
                                            <i class="fa fa-remove"></i>
                                        </button>
                                    </div>
                                </div>
                                <div :id="'cost-' + cost.id" 
                                    class="collapse card-body" 
                                    v-if="cost.data_source === 'manual'">
                                    Total: {{ currency_with_zero(cost.amount) }}<br>
                                    Date: {{ date(cost.date) }}<br>
                                    Cost Type: {{ propercase(cost.cost_type) }}
                                </div>
                                <div :id="'cost-' + cost.id" 
                                    class="collapse card-body" 
                                    v-else>
                                    <strong>Filter Logic:</strong><br>
                                    <div style="line-height: 2.4em;" v-html="logicToString(cost.value.filter_logic, cost.value.logic_units)"></div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <cost-result-modal 
            v-model:modal_version="modal_version" 
            v-model:initiative="init" 
            :client="client" 
            :filter="filter"  
            v-if="modal_version !== null">
        </cost-result-modal>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'InitiativeDetails',
    props: {
        initiative: {
            type: Object,
            required: true
        },
        client: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            init: null,
            modal_version: null,
            filter: {
                data_source: "manual",
                title: "",
                value: null,
                date: null,
                cost_type: 'media_cost',
                emails: 0,
                gifts: 0,
                revenue: 0,
                new_donors: 0,
                recurring_revenue: 0,
                id: null,
                exclude_other_initiatives: false
            },
            errors: {
                date: "",
                title: "",
                value: ""
            },
            form: {
                error: false
            }
        };
    },
    watch: {
        init(oldVal, newVal) {
            //Reset the filter if the initiative gets updated
            this.resetFilter();
        },
        modal_version(oldVal, newVal) {
            //If they closed the modal, then wipe the filter
            if(oldVal === null)
                this.resetFilter();
        }
    },
    beforeMount() {
        this.init = this.initiative;
    },
    methods: {
        resetFilter() {
            this.filter.data_source = "manual";
            this.filter.title = "";
            this.filter.value = null;
            this.filter.date = null;
            this.filter.cost_type = 'media_cost';
            this.filter.emails = 0;
            this.filter.gifts = 0;
            this.filter.revenue = 0;
            this.filter.new_donors = 0;
            this.filter.recurring_revenue = 0;
            this.filter.id = null;
            this.filter.exclude_other_initiatives = false;
        },
        editCost(cost) {
            this.filter.data_source = cost.data_source;
            this.filter.title = cost.description;
            this.filter.date = cost.date;
            this.filter.cost_type = cost.cost_type;
            this.filter.id = cost.id;
            
            if(this.filter.data_source === 'manual')
                this.filter.value = cost.amount;
            else
                this.filter.value = cost.value;

            this.modal_version = 'Cost';
        },
        editResult(result) {
            this.filter.data_source = result.data_source;
            this.filter.title = result.description;
            this.filter.value = result.value;
            this.filter.date = result.date;
            this.filter.id = result.id;
            this.filter.emails = result.emails;
            this.filter.gifts = result.gifts;
            this.filter.revenue = result.revenue;
            this.filter.new_donors = result.new_donors;
            this.filter.recurring_revenue = result.recurring_revenue;
            this.filter.exclude_other_initiatives = result.exclude_other_initiatives;
            this.modal_version = 'Result';
        },
        deleteCost(cost) {
            cost.initiative_id = this.initiative.id;
            window.axios.post('/api/cost/delete/' + cost.id, cost)
                .then(response => {
                    if(response.status === 200) {
                        this.form.successful = true;
                        this.modal_version = null;
                        this.init = response.data.initiative;
                        this.$emit('update:initiative', this.init);
                    } else {
                        this.form.error = true;
                        setTimeout(() => { this.form.error = false; }, 10000);
                    }
                });
        },
        //When deleting results, we have to pass the actual result so it can find the initiative ID
        deleteResult(result) {
            result.initiative_id = this.initiative.id;
            //I have to do a "post" instead of "delete" since I have to pass the initiative_id
            // in cases where it isn't an actual "Result" object
            window.axios.post('/api/result/delete/' + result.id, result)
                .then(response => {
                    if(response.status === 200) {
                        this.form.successful = true;
                        this.modal_version = null;
                        this.init = response.data.initiative;
                        this.$emit('update:initiative', this.init);
                    } else {
                        this.form.error = true;
                        setTimeout(() => { this.form.error = false; }, 10000);
                    }
                });
        },
        logicToString(logic, units) {
            const arr = [];
            for(let i = 0; i < units.length; i++) {
                let str = "<code>" + units[i].db_column.text + " " + units[i].operator + " ";

                //if it is a static date, just format it
                if(units[i].db_column.type === 'date' && units[i].is_static)
                    str += this.date(units[i].value);
                else if(units[i].db_column.type === 'float64' && !isNaN(units[i].value))
                    str += this.currency(units[i].value);
                else if(units[i].db_column.type === 'int' && !isNaN(units[i].value))
                    str += this.number(units[i].value);
                else if(typeof units[i].value === 'object' && units[i].value !== null)
                    str += units[i].value.text;
                else if(typeof units[i].operator === "string" && units[i].operator.indexOf("NULL") === -1)
                    str += units[i].value;
                else if(typeof units[i].operator !== "string" && units[i].operator.value !== null && units[i].operator.value.indexOf("NULL") === -1)
                    str += units[i].value;

                arr.push(str + "</code>");
            }
            for(let i = 0; i < arr.length; i++) {
                const str_num = String(i + 1);
                logic = logic.replaceAll(str_num, arr[i]);
            }
            return logic;
        }
    }
});
</script>
